import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#ffc310",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20 18.8V8.966l1.485.891a1 1 0 1 0 1.03-1.715L17.493 5.13 13.65 2.815a17 17 0 0 0-.675-.394 2 2 0 0 0-.129-.067 1.8 1.8 0 0 0-.417-.152 2 2 0 0 0-.86 0c-.135.03-.267.079-.418.153q-.064.03-.127.065c-.182.097-.396.226-.676.395L6.502 5.133l-5.016 3.01a1 1 0 0 0 1.029 1.714L4 8.967V18.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22H9v-6a3 3 0 1 1 6 0v6h1.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8" }, null, -1)
  ]))]))
}
export default { render: render }